import React, { useEffect, useState } from "react";
import Service from "../Service/http";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Dropdown from 'react-bootstrap/Dropdown';
import Util from "../Service/util";
const ReactTableFixedColumns = withFixedColumns(ReactTable);


function DisplayCriteria() {
  const service = new Service();
  const util =  new Util();
  const userId = util.getId(); 
  let [data, SetData] = useState({});
  let [loading, setLoading] = useState(true);
  let [criterias,setCriterias] = useState([])
  let [criteria,setCriteria] = useState("")
  let [userData, setUserData] = useState([]);
  let [criteriaMap, setCriteriaMap] = useState({});
  const role = util.getRole()

  useEffect(() => {
    service.get(`api/user/stats/${userId}`).then(response => {
      setUserData(response.data);
      setLoading(false);
    }).catch(error => {
      console.error("Error fetching user stats:", error);
      setLoading(false);
    });
  }, [userId]);
  

  useEffect(()=>{
    if(role!="student"){
      service.get("api/all/criteria").then(json => {
        setCriterias(json)
        setCriteria(json[0])
      })
      .catch((err)=>{
        console.error(err)
      })
    }else{
        service.get("api/batches").then(json => {
            setCriterias(Object.keys(json.criteriaMap));
            setCriteria(Object.keys(json.criteriaMap)[0]);
            setCriteriaMap(json.criteriaMap);
        })
        .catch((err) =>{
          console.log(err);
        })
      }
    },[])
  useEffect(()=>{
    if(criteria){
    service.get("api/all/sites/criteriaByName/"+criteria).then(json => {
      SetData(json.result);
      
    }).catch(error => {
      console.log(error);
    }).finally(() => {
          setLoading(false);
    })}
  },[criteria])

  const checkUserMeetsCriteria = (rowData) => {

    const { platform, criteria, mqc } = rowData;

    let criteriaMeet = false;

    const userPlatFormData = userData[platform];
    if(userPlatFormData) criteriaMeet = userPlatFormData[criteria] >= mqc;
    
    return criteriaMeet;
  };

  return <div className="container mt-1">
    <br></br>
    <div style={{ textAlign:"center"}}>
        <Dropdown style={{marginTop: "2vh", marginBottom: "2vh",marginRight: "2vh", size: "xs" ,display:"inline"}} >
          <Dropdown.Toggle className="custom-button" style={{backgroundColor:"#1b9369"}}>
          {criteria ? (criteriaMap[criteria] ? `${criteria} (${criteriaMap[criteria]})` : criteria) : "Select Criteria"}
          </Dropdown.Toggle>

          <Dropdown.Menu style={{width: "max-content", minWidth: "100%"}}>
            {criterias.map((criteria_name)=>{
              return (<Dropdown.Item active={criteria_name == criteria } style={{textAlign: 'center', fontWeight: 'bolder'}} onClick={()=>{setCriteria(criteria_name)}}>{criteriaMap[criteria_name] ? `${criteria_name} (${criteriaMap[criteria_name]})` : criteria_name}</Dropdown.Item>)
            })}
          </Dropdown.Menu>
        </Dropdown>
        </div>

    <br />

    {loading && <div className="d-flex justify-content-center align-items-center">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>}

    {Object.keys(data).length === 0 && !loading &&
      <div className="alert alert-dismissible alert-warning">
        <button type="button" className="btn-close" data-bs-dismiss="alert"></button>
        <strong>No data found..</strong>
      </div>
    }

    {Object.keys(data).length > 0 && !loading
      && <>
            {Object.keys(data).map((phase, index) => {

              return <>
                <ReactTableFixedColumns
                  data={data[phase]}
                  pageSize={data[phase]?.length}
                  showPagination={false}
                  columns={[{
                    Header: 'PLATFORM',
                    accessor: 'platform',
                    headerClassName: 'border border-right p-2 bg-secondary text-black',
                    getProps: (state, rowInfo, column) => {
                      return {
                        style: {
                          color: 'BLACK',
                          background: rowInfo && checkUserMeetsCriteria(rowInfo.original) 
                          ? '#c9ffc9'  
                          : 'transparent',
                          border: 0,
                          borderRight: '1px solid silver',
                          textAlign:'center'
                          
                        },
                      };
                    },
                  },
                  {
                    Header: 'METRIC',
                    accessor: 'metric',
                    headerClassName: 'border border-right bg-secondary text-black',
                    getProps: (state, rowInfo, column) => {
                      return {
                        style: {
                          color: 'black',
                          background: rowInfo && checkUserMeetsCriteria(rowInfo.original) 
                          ? '#c9ffc9'  
                          : 'transparent',
                          border: 0,
                          borderRight: '1px solid silver',
                          textAlign:'center'
                        },
                      };
                    },
                  },
                  {
                    Header: 'MINIMUM QUALIFICATION CRITERIA',
                    accessor: 'mqc',
                    headerClassName: 'border border-right bg-secondary text-black',
                    getProps: (state, rowInfo, column) => {
                      return {
                        style: {
                          color: 'black',
                          background: rowInfo && checkUserMeetsCriteria(rowInfo.original) 
                          ? '#c9ffc9'  
                          : 'transparent',

                          padding:15,
                          border: 0,
                          textAlign:'center'
                        },
                      };
                    },
                  }]}
                
                  className=" -highlight text-dark h5"
                  getTheadProps={() => ({
                    style: {
                      boxShadow: "none", 
                    },
                  })}
                />
                <div style={{
                  height: "50px"
                }} />
              </>

            })}
      </>
    }


  </div>;
}

export default DisplayCriteria;
